import useStyles from './styles';
import type { ScrollPanelProps } from './types';

/**
 * The scroll area of a fixed-size panel — the layout's, not its content's.
 *
 * Content renders at its natural height and never decides whether it scrolls;
 * the panel hosting it does. So the same content sits in a scrolling panel
 * inside this app and on a scrolling page elsewhere — gen.ai's `/assets` mounts
 * the creations grid (`./Creations`) straight into its page, which scrolls.
 */
const ScrollPanel = ({ children }: ScrollPanelProps) => {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
};

export default ScrollPanel;
